module.exports = __webpack_public_path__ + "static/media/second.347a88f1.jpeg";